import { useContext, useEffect, useRef } from 'react'

import { GLOBAL_ACCESS_ROLE, WorkspacesContext } from '@/components/dashboard/layout/workspaces/workspaces-context'
import { useImpersonation } from '@/contexts/impersonation/impersonation-context'
import { useUser } from '@/hooks/use-user'
import { identifyUser, resetAnalytics, setOperatorContext } from '@/lib/segment'

export function SegmentIdentify() {
	const { user } = useUser()
	const { isImpersonating } = useImpersonation()
	const workspaces = useContext(WorkspacesContext)
	const previousUserId = useRef<string | null>(null)

	const isGlobalUser = !!user?.roles?.includes(GLOBAL_ACCESS_ROLE)
	const operator = workspaces.currentOperator ?? user?.portal_operator

	useEffect(() => {
		setOperatorContext(operator, isGlobalUser)
	}, [operator, isGlobalUser])

	useEffect(() => {
		if (isImpersonating) return

		if (user?.username && user.username !== previousUserId.current) {
			previousUserId.current = user.username
			const traits: Record<string, unknown> = {
				email: user.email,
				name: user.name,
				tags: user.tags,
			}

			if (isGlobalUser) {
				traits.role = 'global'
			} else if (operator) {
				traits.operatorId = operator.id
				traits.operatorName = operator.name
			}

			identifyUser(user.username, traits)
		} else if (!user && previousUserId.current) {
			previousUserId.current = null
			resetAnalytics()
		}
	}, [user, isImpersonating, operator, isGlobalUser])

	return null
}
